import React, { Component } from "react";
import {
  Route,
  Switch,
  BrowserRouter as Router,
  withRouter,
} from "react-router-dom";

import { LanguageProvider } from "./contexts/LanguageContext";
import DataWizard from "./components/wizard/DataWizardWrapper";
import DirectChargePage from "./components/directCharge/DirectChargePage";

const getBasename = (path) => path.substr(0, path.lastIndexOf("/"));

class App extends Component {
  render() {
    return (
      <LanguageProvider>
        <Router basename={getBasename(window.location.pathname)}>
          <Switch>
            <Route path="/charge" component={DirectChargePage} />
            <Route path="/" component={DataWizard} />
          </Switch>
        </Router>
      </LanguageProvider>
    );
  }
}

export default withRouter(App);
